"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactCopyToClipboard = require("react-copy-to-clipboard");

var CopyText = function CopyText(_ref) {
  var text = _ref.text,
      children = _ref.children,
      duration = _ref.duration,
      copiedHint = _ref.copiedHint;

  // Verifies that children has only one child (a React element) and returns it.
  var childElement = _react["default"].Children.only(children);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  var timer = (0, _react.useRef)();
  var clearTimer = (0, _react.useCallback)(function () {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }, []);
  var handleCopy = (0, _react.useCallback)(function () {
    // The text was copied
    setCopied(true);
    clearTimer();
    timer.current = setTimeout(function () {
      // Reset status after duration
      setCopied(false);
    }, duration);
  }, [clearTimer, duration]);
  (0, _react.useEffect)(function () {
    return clearTimer;
  }, [clearTimer]);
  return (0, _jsxRuntime.jsx)(_reactCopyToClipboard.CopyToClipboard, {
    text: text,
    onCopy: handleCopy,
    children: /*#__PURE__*/(0, _react.cloneElement)(childElement, {
      children: copied ? copiedHint : childElement.props.children
    })
  });
};

CopyText.propTypes = {
  text: _propTypes.string,
  duration: _propTypes.number,
  children: _propTypes.node,
  copiedHint: _propTypes.string
};
CopyText.defaultProps = {
  text: undefined,
  duration: 5000,
  children: undefined,
  copiedHint: 'Copied'
};
var _default = CopyText;
exports["default"] = _default;
//# sourceMappingURL=CopyText.js.map